import { useEffect, useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { xosoService } from "@/services/xosoService";
import { drawDateKey, HISTORY_DAYS } from "./constants";

dayjs.extend(utc);

export default function useDienToan123(date, days = HISTORY_DAYS) {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [resolvedDate, setResolvedDate] = useState(date || null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    (async () => {
      let latest = null;
      let anchor = date || null;
      if (!anchor) {
        latest = await xosoService.getDienToan123();
        anchor = drawDateKey(latest?.drawDate);
        if (!anchor) {
          if (!cancelled) {
            setResults([]);
            setResolvedDate(null);
            setLoading(false);
          }
          return;
        }
      }

      const dates = Array.from({ length: days }, (_, i) =>
        dayjs(anchor).subtract(i, "day").format("YYYY-MM-DD")
      );
      const items = (
        await Promise.all(
          dates.map((d) => {
            if (latest && d === anchor) return Promise.resolve(latest);
            return xosoService.getDienToan123({ date: d });
          })
        )
      ).filter(Boolean);
      items.sort((a, b) => dayjs(b.drawDate).valueOf() - dayjs(a.drawDate).valueOf());

      if (!cancelled) {
        setResults(items);
        setResolvedDate(anchor);
        setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [date, days]);

  return { results, loading, resolvedDate };
}
